import loadGuesses from './loadGuesses'

function saveGuesses (answers) {
  answers = Object.assign({}, loadGuesses(), answers)
  window.localStorage.setItem('answer-guesses', JSON.stringify(answers))
}

export default saveGuesses
